<template>
  <div>
    <ImgDialog ref="imgDialog" @updateFeedback="updateFeedback" />
    <VideoDialog ref="videoDialog" @updateFeedback="updateFeedback" @updateRead="updateRead" />
    <IframeDialog ref="iframeDialog" />
    <HomeDrawer ref="homeDrawer" @click="onHistoryClick" />
    <!-- 历史记录-翻页中转弹窗 -->
    <PagerDialog ref="pagerDialog" @click="onPagerClick" @page-change="onPagerChange"/>
  </div>
</template>

<script>
  import ImgDialog from './img-dialog'
  import IframeDialog from './iframe-dialog'
  import VideoDialog from './video-dialog'
  import HomeDrawer from '../drawer'
  import PagerDialog from './pager-dialog.vue'
  import {handleJumpTo, isBannerImg} from './utils'
  export default {
    components: { ImgDialog, IframeDialog, VideoDialog, HomeDrawer, PagerDialog },
    methods: {
      onHistoryClick (item, list) {
        // 打开历史记录-分页弹窗
        this.open('pagerDialog', item, list)
      },
      // 历史记录-翻页中转弹窗-点击
      onPagerClick (item) {
        // 发布类型区分视频与图片
        if (isBannerImg(item)) {
          // 包含 /inform-video/#/?media 的链接 打开嵌套iframe视频弹窗
          const urls = ['/inform-video/#/?media', '/ky-style-video/#/?media', '/ky-style/#/detail']
          if (item.accessUrl && urls.some(url => item.accessUrl.includes(url))) {
            this.open('iframeDialog', item.accessUrl)
            return
          }
          this.onImgClick(item)
          return
        }
        this.$refs.videoDialog.open(item)
      },
      onImgClick (item) {
        this.updateFeedback()
        // 跳转
        handleJumpTo(item)
      },
      // 历史记录-翻页中转弹窗-翻页 响应回调
      onPagerChange (item) {
        this.updateRead(item)
        if (isBannerImg(item)) {
          this.updateFeedback()
        } else {
          this.updateFeedback(item)
        }
      },
      updateFeedback (data) {
        this.$emit('updateFeedback', data)
      },
      updateRead (data) {
        this.$emit('updateRead', data)
      },
      open (dialogComp, data, extraData) {
        this.$refs[dialogComp].open(data, extraData)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/layout/pages/home/banner/banner-dialog.vue